import { SET_ERROR, SET_LIST, SET_LOADING } from '../Actions/organization';
import Organization from '../Entities/Organization';

interface IState {
    list: Organization[],
    error: string | null;
    isLoading: boolean;
};

const defaultState = {
    list: [],
    error: null,
    isLoading: false
};

export default function organization(state: IState = defaultState, action: any) {
    switch (action.type) {
        case SET_LIST:
            return {
                ...state,
                list: action.data,
                pages: action.pages,
                currentPage: action.currentPage,
                isLoading: false
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case SET_LOADING:
            return {
                ...state,
                isLoading: action.isLoading
            }
        default:
            return state;
    }
}
